import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchPendingApprovalList } from "../../redux";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import style from "./PendingApprovalList.module.css";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Dropdown from "../../utils/Dropdown.json";
import api from "../../utils/Api";
import moment from "moment";
import ttmLodader from "../../assets/images/ttm-loader.gif";
import history from "../../utils/history";

function dateFormatter(cell) {
  if (!cell) {
    return "";
  }
  return `${
    moment(cell).format("YYYY-MM-DD")
      ? moment(cell).format("YYYY-MM-DD")
      : moment(cell).format("YYYY-MM-DD")
  }`;
}
export class PendingApprovalList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      related_party_id: "",
      isModalOpen: false,
      searchKey: "",
      page: 1,
      sortName: undefined,
      sortOrder: undefined,
      sortBy: "",
      successMessage: "",
      errorMessage: "",
      errorField: "",
      system_role:
        localStorage.getItem("USER_INFO") &&
        JSON.parse(localStorage.getItem("USER_INFO")).systemRole,
      isPendingDeletionScreen: 1,
      fullname: "",
      type: "",
      deletionReason: "",
      email: "",
      physicalAddress: "",
      product_name: "",
      inventory_id: "",
      sub_category_name: "",
      unique_code: "",
      isDataFetched: false,
      pendingApprovalList: [],
      selectedList: "contact"
    };
    this.toggle = this.toggle.bind(this);
    this.onSubmitApproveDelete = this.onSubmitApproveDelete.bind(this);
    this.setLoader = this.setLoader.bind(this);
  }

  componentDidMount = async() => {
    document.title = 'Pending Approval List - TechToMedix';
   await this.props.fetchPendingApprovalList(
      this.state.searchKey,
      this.state.sortBy,
      this.state.page,
      this.state.isPendingDeletionScreen,
      this.state.selectedList
    );
    if(this.props.pendingApprovalListData &&
      this.props.pendingApprovalListData.pendingApprovalList.relatedParty && this.state.selectedList === "contact") {
      this.setState({
        pendingApprovalList: this.props.pendingApprovalListData.pendingApprovalList.relatedParty
      })
    }
    
    if(this.props.pendingApprovalListData &&
      this.props.pendingApprovalListData.pendingApprovalList.relatedParty && this.state.selectedList === "inventory") {
      this.setState({
        pendingApprovalList: this.props.pendingApprovalListData.pendingApprovalList.inventory
      })
    }
    setTimeout(() => {
      if (
        (this.props.pendingApprovalListData &&
          this.props.pendingApprovalListData.pendingApprovalList.length ===
            0) ||
        this.props.pendingApprovalListData.pendingApprovalList.total === 0
      ) {
        this.setState({
          isDataFetched: true,
        });
      } else {
        this.setState({
          isDataFetched: false,
        });
      }
    }, 1000);
  }

  callPendingApprovalList = async() => {
    this.setState({
      pendingApprovalList: []
    })
   await this.props.fetchPendingApprovalList(
      this.state.searchKey,
      this.state.sortBy,
      this.state.page,
      this.state.isPendingDeletionScreen,
      this.state.selectedList
    );
    if(!this.props.pendingApprovalListData.loading){
      if(this.state.selectedList === "contact"){
        this.setState({
          pendingApprovalList: this.props.pendingApprovalListData.pendingApprovalList.relatedParty
        })
      }else{
      this.setState({
        pendingApprovalList: this.props.pendingApprovalListData.pendingApprovalList.inventory
      })
      }
      setTimeout(() => {
          this.setState({
            isDataFetched: true,
          });
      }, 1000);
    }
  }

  // toggle a modal
  async toggle(value) {
    if(this.state.selectedList === "contact"){
      
        this.setState((prevState) => ({
          related_party_id: value.related_party_id,
          deletionReason: value.deleted_reason,
          isModalOpen: !prevState.isModalOpen,
        }));
        //if pop up is already open then no need to call API
        if(this.state.isModalOpen === true){
          return false;
        }
        // API on click of pending approval tick sign
        const related_party_id = value.related_party_id;
        const headers = {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
        };
        try {
          const response = await api.get("relatedparty/" + related_party_id, {
            headers: headers,
          });
          const data = response.data.data;
          this.setState({
            fullname: `${data.relatedPartyDetails.name} ${data.relatedPartyDetails.surname}`,
            type: data.relatedPartyDetails.related_party_type,
            deletionReason: this.state.deletionReason,
            email: data.relatedPartyDetails.email,
            physicalAddress: data.relatedPartyDetails.physical_address,
          });
        } catch (error) {
          console.log("Error is - ", error);
        }
      }

      
    if(this.state.selectedList === "inventory"){
      this.setState((prevState) => ({
        inventory_id: value.inventory_id,
        deletionReason: value.deletion_reason,
        product_name: value.product_name,
        sub_category_name: value.sub_category_name,
        unique_code: value.unique_code,
        isModalOpen: !prevState.isModalOpen,
      }));
    }
  }

  actionsFormatter(cell, row) {
    return (
      <div>
        <i title="Delete Contact"
          className={`fa fa-trash ${style.faCheck}`}
          onClick={() => this.toggle(row)}
        ></i>
      </div>
    );
  }

  async onSubmitApproveDelete(flagNumebr) {
     this.setState(() => ({
          errorMessage: "",
        }));
    let url = "";
    let data = {};
    if(this.state.selectedList === "contact"){
      url = "relatedparty/deletion/approve";
      data = {
        related_party_id: this.state.related_party_id,
        approveDeletion: Number(flagNumebr),
      }
    }else{
      url = "inventory/deletion/approve";
      data = {
        inventory_id: this.state.inventory_id,
        approveDeletion: Number(flagNumebr),
      }
    }

    try {
      const response = await api.delete(url, {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
        },
        data,
      });
      if (response.status === 200) {
        this.setState({
          successMessage: Number(flagNumebr) === 1?"Deletion request approved!":"Deletion request rejected!",
        });

        setTimeout(() => {
          this.setState((prevState) => ({
            successMessage: "",
            isModalOpen: !prevState.isModalOpen,
          }));
          this.callPendingApprovalList();
        }, 3000);
      }
    } catch (error) {
      console.log("error",error.response);
      this.setState({
        errorMessage:  error.response && error.response.data && error.response.data.message?error.response.data.message:"Some error occured!",
      });
      // setTimeout(() => {
      //   this.setState(() => ({
      //     errorMessage: "",
      //   }));
      // }, 3000);
    }
  }
  

  onSortChange = (sortName, sortOrder) => {
    let sortBy;
    if (sortOrder == "desc") {
      sortBy = "-" + sortName;
    } else {
      sortBy = sortName;
    }
    this.setState({
      sortName,
      sortOrder,
      sortBy,
      page: 1,
      isDataFetched: false,
    },()=>{
      if (sortName != "any") {
        this.callPendingApprovalList();
      }
    });
  };

  onSearchChange = (event) => {
    this.setState({ 
      searchKey: event.target.value, 
      page: 1, 
      isDataFetched: false 
    },()=>{
      this.callPendingApprovalList();
    });
  };

  onPageChange = (page, sizePerPage) => {
    this.setState({ 
      page, 
      isDataFetched: false 
    },()=>{
      this.callPendingApprovalList();
    });
  };

  setLoader() {
    if (this.state.isDataFetched) {
      return <p>There is no data to display</p>;
    } else {
      return (
        <div>
          <img src={ttmLodader} alt="loader" className="loader-image" />
        </div>
      );
    }
  }

  
  handleOptionChange = (event) => {
    this.setState({
      selectedList: event.target.value,
      searchKey:"",
      page: 1,
      sortName: undefined,
      sortOrder: undefined,
      sortBy: "",
      isDataFetched: false 
    },()=>{
      this.callPendingApprovalList();
    });
  };

  goBack = () => {
    history.goBack();
  }

  render() {
    return (
      <div className={style.relatedPartiesListMainWarapper}>
        <div className="">
          <div className={style.relatedPartiesListMainWarapper}>
          {this.props.location.state && 
      this.props.location.state.fromNotifications === 1 &&  ( 
        <div className="mb-2">
            <span className="goBackBtn" onClick={this.goBack}>
              <i class="fa fa-arrow-left" aria-hidden="true"></i>{" "}
              Go Back to Notifications</span>
          </div>)}
            <div className="row">
              <div class="col-md-7">
                <h3>Pending Approvals for Deletion</h3>
              </div>
              <div
                className={`col-md-5 order-3 order-md-2 d-flex justify-content-start justify-content-md-end `}
              >
               <div className="form-group">
                  <input
                    type="text"
                    className={`form-control ${style.inputSearch}`}
                    id="search"
                    placeholder="Search here"
                    value={this.state.searchKey}
                    onChange={this.onSearchChange}
                  />
                </div>
              </div>
            </div>
            <div className="row">
            <div class="col-md-12">
                <p>
                  This is the list of the {this.state.selectedList==="contact"?"contacts":"products"} which are awaiting the super
                  administrator approval for deletion. When the super
                  administrator approves the deletion request, the deleted{" "}
                  {this.state.selectedList==="contact"?"contact":"product"} will be listed under "Archived Contacts" on left
                  sidebar
                </p>
              </div>
            </div>
            <div className={`row mb-3 mt-3 ${style.listType}`}>
          <div className="col-lg-12 d-flex">
            <label className="mr-3">List Type :</label>
            <div>
              <div className="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  className="custom-control-input"
                  id="contact"
                  name="selectedList"
                  value="contact"
                  checked={this.state.selectedList === "contact"}
                  onChange={this.handleOptionChange}
                />
                <label className="custom-control-label" htmlFor="contact">
                Contacts
                </label>
              </div>
              <div className="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  className="custom-control-input"
                  id="inventory"
                  name="selectedList"
                  value="inventory"
                  checked={this.state.selectedList === "inventory"}
                  onChange={this.handleOptionChange}
                />
                <label className="custom-control-label" htmlFor="inventory">
                Products
                </label>
              </div>
            </div>
          </div>
        </div>
            <div className="row related-parties-list">
              <div className="col-md-12">
                <BootstrapTable
                  bordered={false}
                  remote={true}
                  data={this.state.pendingApprovalList
                  }
                  version="4"
                  search={false}
                  pagination
                  fetchInfo={{
                    dataTotalSize: this.props.pendingApprovalListData
                      .pendingApprovalList.total,
                  }}
                  options={{
                    searchvalue: "",
                    sortName: this.state.sortName,
                    sortOrder: this.state.sortOrder,
                    onSortChange: this.onSortChange,
                    onSearchChange: this.onSearchChange,
                    sizePerPage: 10,
                    page: this.state.page,
                    onPageChange: this.onPageChange,
                    noDataText: this.setLoader(),
                  }}
                >
                  {this.state.selectedList === "contact" && (
                  <TableHeaderColumn
                    dataField="name"
                    isKey
                    width="25%"
                    dataSort={true}
                  >
                    Contact Name
                  </TableHeaderColumn>)}
                  {this.state.selectedList === "contact" && (
                  <TableHeaderColumn
                    dataField="deleted_reason"
                    width="25%"
                    dataSort={true}
                  >
                    Deletion reason
                  </TableHeaderColumn>
                  )}
                   {this.state.selectedList === "inventory" && (
                  <TableHeaderColumn
                    dataField="product_name"
                    isKey
                    width="25%"
                    dataSort={true}
                  >
                    Product Name
                  </TableHeaderColumn>)}
                  {this.state.selectedList === "inventory" && (
                  <TableHeaderColumn
                    dataField="deletion_reason"
                    width="25%"
                    dataSort={true}
                  >
                    Deletion reason
                  </TableHeaderColumn>
                  )}
                  <TableHeaderColumn
                    dataField="deletion_request_date"
                    width="20%"
                    dataSort={true}
                    dataFormat={dateFormatter}
                  >
                    Date
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="raisedRequestBy"
                    width="20%"
                    dataSort={true}
                  >
                    Raised By
                  </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="actions"
                      dataFormat={this.actionsFormatter.bind(this)}
                      width="10%"
                      className={style.deleteAction}
                      dataAlign="center"
                    >
                      Approve
                    </TableHeaderColumn>
                </BootstrapTable>
              </div>
            </div>
          </div>

          {/* Open a modal for details of reason request */}
          <Modal
            isOpen={this.state.isModalOpen}
            toggle={this.toggle}
            className={style.deleteReason}
            centered
          >
            <ModalHeader
              toggle={this.toggle}
              className={style.deleteModalHeader}
            >Details of deletion Request</ModalHeader>
            <ModalBody>
              {/* <div className={style.deleteReasonHeadingWrapper}>
                <h4>Details of deletion Request</h4>
              </div> */}
              <div className={style.deleteReasonFormWrapper}>
                <form onSubmit={this.onSubmit}>
                  {this.state.selectedList=== "contact" && (
                  <React.Fragment>
                    <div className="row">
                      <div className="col-md-4">
                        <label>Name:</label>
                      </div>
                      <div className="col-md-8">{this.state.fullname}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <label>Type:</label>
                      </div>
                      <div className="col-md-8">{this.state.type}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <label>Reason for deletion: </label>
                      </div>
                      <div className="col-md-8">{this.state.deletionReason}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <label>Email Id:</label>
                      </div>
                      <div className="col-md-8">{this.state.email}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <label>Physical Address:</label>
                      </div>
                      <div className="col-md-8">{this.state.physicalAddress}</div>
                    </div>
                  </React.Fragment>
                  )}
                  {this.state.selectedList=== "inventory" && (
                  <React.Fragment>
                    <div className="row">
                      <div className="col-md-4">
                        <label>Product Name:</label>
                      </div>
                      <div className="col-md-8">{this.state.product_name}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <label>Unique Code:</label>
                      </div>
                      <div className="col-md-8">{this.state.unique_code}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <label>Subcategory:</label>
                      </div>
                      <div className="col-md-8">{this.state.sub_category_name}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <label>Reason for deletion: </label>
                      </div>
                      <div className="col-md-8">{this.state.deletionReason}</div>
                    </div>
                  </React.Fragment>
                  )}
                  <p>
                    <label>Do you want to approve deletion?</label>
                  </p>
                  <div className={`row ${style.deleteBtnWrapper}`}>
                    <div className="col-md-12">
                      <button
                        type="button"
                        className={`mr-3 ${style.yesBtn}`}
                        onClick={() => this.onSubmitApproveDelete("1")}
                      >
                        Yes
                      </button>

                      <button
                        type="button"
                        className={style.noBtn}
                        onClick={() => this.onSubmitApproveDelete("0")}
                      >
                        No
                      </button>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <p className={style.successMessage}>
                        {this.state.successMessage}
                      </p>
                      <p className={style.errorMessage}>
                        {this.state.errorMessage}
                      </p>
                    </div>
                  </div>
                </form>
              </div>
            </ModalBody>
          </Modal>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    pendingApprovalListData: state.pendingApprovalList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPendingApprovalList: (
      searchKey,
      sortBy,
      page,
      isPendingDeletionScreen,
      selectedList
    ) =>
      dispatch(
        fetchPendingApprovalList(
          searchKey,
          sortBy,
          page,
          isPendingDeletionScreen,
          selectedList
        )
      ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PendingApprovalList);
